$(document).ready(function() {

	// initialize #autocomplete-form
	if ($('#autocomplete-form').length > 0) {
		autocomplete();
		initialSearchForm();
	}

	// highlight menu items on scroll
	function highlight_menu_items_on_scroll(sections, header_height) {
		var current_position = $(window).scrollTop() + header_height;
		var sections_above_header = 0;
		$(sections).each(function(index, section) {
			var section_id = $(section).attr('id');
			var section_position = $(section).offset().top;
			if (current_position > section_position) {
				$('.primary-nav a').parent().removeClass('menu-item-active');
				$('.primary-nav a[href*="#' + section_id + '"]').parent().addClass('menu-item-active');
				sections_above_header = sections_above_header + 1;
			}
		});
		if (sections_above_header === 0) {
			$('.primary-nav a').parent().removeClass('menu-item-active');
		}
	}

	if ($('body').hasClass('page-template-page-peak-home')) {
		var sections = $('.js-peak-watcher');
		if (sections) {
			var header_height = $('.site-header').outerHeight() + 1;
			highlight_menu_items_on_scroll(sections, header_height);
			$(window).scroll(function() {
				// watch sections on scroll and update menu highlighting on the fly
				highlight_menu_items_on_scroll(sections, header_height);
			});
		}
	}

	// trigger animations on scroll
	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('peak-item-active');
				observer.unobserve(entry.target);
			}
		});
	}, { threshold: 0.5 });

	const services = document.querySelectorAll('.peak-service');
	if (services) {
		services.forEach(service => {
			observer.observe(service);
		});
	}

	const markets = document.querySelectorAll('.peak-market');
	if (markets) {
		markets.forEach(market => {
			observer.observe(market);
		});
	}

	const values = document.querySelectorAll('.peak-value');
	if (values) {
		values.forEach(value => {
			observer.observe(value);
		});
	}

	const team_members = document.querySelectorAll('.peak-team-card');
	if (team_members) {
		team_members.forEach(team_member => {
			observer.observe(team_member);
		});
	}

	const content_card_items = document.querySelectorAll('.peak-content-card-item');
	if (content_card_items) {
		content_card_items.forEach(content_card_item => {
			observer.observe(content_card_item);
		});
	}

	// expand/collapse faq questions
	$('.peak-faq-question').on('click', function() {
		$(this).parent('.peak-faq').toggleClass('peak-faq-active');
	});

	// contact form functionality
	$('#peak-contact-form').validate({
		// debug: true,
		errorElement: 'span',
		errorClass: 'form-field-error',
		validClass: 'form-field-valid',
		errorPlacement: function (error, element) {
			error.appendTo(element.parents('.form-field'));
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
		},
		rules: {
			'name': {
				required: true,
				minlength: 2
			},
			'email': {
				required: true,
				email: true
			},
			'phone-number' : {
				required: false,
				phoneUS: true
			},
			'message': {
				required: true,
				minlength: 2
			}
		},
		messages: {
			'name': {
				required: 'Please enter your name.',
				minlength: 'Your name must be at least 2 characters long.'
			},
			'email': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			},
			'phone-number': {
				phoneUS: 'Please enter a valid phone number.'
			},
			'message': {
				required: 'Please explain how we can help you.',
				minlength: 'Your message must be at least 2 characters long.'
			}
		},
		submitHandler: function(form) {

			$('.button-spinner').prop('disabled', true);

			var name = $('#name', form).val();
			var email = $('#email', form).val();
			var phone_number = $('#phone-number', form).val();
			var message = $('#message', form).val();
			var nonce = $('#peak-contact-form-nonce', form).val();

			$.ajax({
				type: 'post',
				url: '/wp-admin/admin-ajax.php',
				data: {
					action: 'peak_contact_form',
					name: name,
					email: email,
					phone_number: phone_number,
					message: message,
					nonce: nonce
				},
				success: function(results) {
					var results = JSON.parse(results);
					console.log(results);
					if (results.status === 'success') {
						// it worked!
						$('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
					} else if (results.status === 'error') {
						// it didn't work?
						$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
					} else {
						// something else happened
						$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong? Please try again.');
					}
					$('.button-spinner').prop('disabled', false);
				},
				error: function(results) {
					var results = JSON.parse(results);
					console.log(results);
					$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong? Please try again.');
					$('.button-spinner').prop('disabled', false);
				}
			});
		}
	});

	// calculate car wash reservation prices
	function peak_calculate_car_wash_price() {
		// get the current total price
		var current_price = Number($('#car-wash-total-price').val());

		// get service type price
		var service_type_price = Number($('input[name="coupon-options"]:checked').attr('data-price-pennies'));
		console.log('service_type_price:', service_type_price);

		// get add-on services price
		var add_on_services = $('input[name="add-on-services"]');
		var add_on_services_price = 0;
		if (add_on_services) {
			$(add_on_services).each(function(index, service) {
				if ($(service).is(':checked')) {
					add_on_services_price = Number(add_on_services_price) + Number($(service).attr('data-price-pennies'));
				}
			});
		}
		console.log('add_on_services_price:', add_on_services_price);

		// add 'em up and stuff
		var new_price = Number(current_price) + Number(service_type_price) + Number(add_on_services_price);
		// var new_deposit_price = Number(new_price) / 2;
		var new_display_price = Number(new_price) / 100;
		// var new_display_deposit_price = Number(new_deposit_price) / 100;

		// populate inputs and display prices
		$('#total-price').val(new_price);
		$('#price').val(new_price);
		$('#car-wash-total-price').empty().text(new_display_price.toFixed(2));
		// $('#car-wash-deposit-price').empty().text(new_display_deposit_price.toFixed(2));
	}

	if ($('body').hasClass('page-template-page-peak-car-wash')) {
		// car wash login/create tabs functionality
		$('.peak-car-wash-tabs-menu-button').on('click', function(e) {
			e.preventDefault();
			var tab = $(this).attr('data-tab');
			$('.peak-car-wash-tabs-menu-button').removeClass('peak-car-wash-tabs-menu-button-active');
			$('.peak-car-wash-tab').removeClass('peak-car-wash-tab-active');
			$(this).addClass('peak-car-wash-tabs-menu-button-active');
			$('.peak-car-wash-tab[data-tab="' + tab + '"]').addClass('peak-car-wash-tab-active');
		});
		// recalculate price when changing options
		$('input[name="coupon-options"], input[name="add-on-services"]').on('change', function() {
			peak_calculate_car_wash_price();
		});
	}

	$('#apply-promo-code').on('click', function(e) {
		e.preventDefault();
		var promo_code = $('#promo-code').val();
		if (promo_code) {

			$('#apply-promo-code').prop('disabled', true);

			var parking_type = 'coupon';
			var facility_id = $('#facility-id').val();

			$.ajax({
				type: 'post',
				url: '/wp-admin/admin-ajax.php',
				data: {
					action: 'calculate_product_price',
					facilityId: facility_id,
					parkingType: parking_type,
					promoCode: promo_code
				},
				success: function (results) {
					var results = JSON.parse(results);
					console.log(results);
					if (results.status == 'success') {
						// remove default options, replace with promo code product
						$('#service-type').empty().append(results.productTemplate);
						// update price to promo code price
						peak_calculate_car_wash_price();
						// display success message
						$('.peak-car-wash-promo-code .form-field-message').empty().removeClass('form-field-message-error').addClass('form-field-message-success').text(results.message);
						// turn off button spinner
						$('#apply-promo-code').prop('disabled', false);
					} else {
						// display error message
						$('.peak-car-wash-promo-code .form-field-message').empty().removeClass('form-field-message-success').addClass('form-field-message-error').text(results.message);
						// turn off button spinner
						$('#apply-promo-code').prop('disabled', false);
					}
				},
				error: function (results) {
					var results = JSON.parse(results);
					console.log(results);
				}
			});
		}
	});

	// car wash reservation checkout
// 	$('#peak-car-wash-reservation').validate({
// 		// debug: true,
// 		errorElement: 'span',
// 		errorClass: 'form-field-error',
// 		validClass: 'form-field-valid',
// 		errorPlacement: function (error, element) {
// 			error.appendTo(element.parents('.form-field'));
// 		},
// 		highlight: function (element, errorClass, validClass) {
// 			$(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
// 		},
// 		unhighlight: function (element, errorClass, validClass) {
// 			$(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
// 		},
// 		rules: {
// 			'facility': {
// 				required: true
// 			},
// 			'first-name': {
// 				required: true,
// 				minlength: 2
// 			},
// 			'last-name': {
// 				required: true,
// 				minlength: 2
// 			},
// 			'email': {
// 				required: true,
// 				email: true
// 			},
// 			'phone-number': {
// 				required: false,
// 				phoneUS: true
// 			},
// 			'vehicle-year': {
// 				required: true
// 			},
// 			'vehicle-make': {
// 				required: true
// 			},
// 			'vehicle-model': {
// 				required: true
// 			},
// 			'service-type': {
// 				required: true
// 			},
// 			'date-of-service': {
// 				required: true
// 			},
// 			'time-of-day': {
// 				required: true
// 			}
// 		},
// 		messages: {
// 			'facility': {
// 				required: 'Please select a facility.'
// 			},
// 			'first-name': {
// 				required: 'Please enter your first name.',
// 				minlength: 'Your name must be at least 2 characters long.'
// 			},
// 			'last-name': {
// 				required: 'Please enter your last name.',
// 				minlength: 'Your name must be at least 2 characters long.'
// 			},
// 			'email': {
// 				required: 'Please enter your email address.',
// 				email: 'Please enter a valid email address.'
// 			},
// 			'phone-number': {
// 				phoneUS: 'Please enter a valid phone number.'
// 			},
// 			'vehicle-year': {
// 				required: 'Please choose a year.'
// 			},
// 			'vehicle-make': {
// 				required: 'Please enter the make of your vehicle.'
// 			},
// 			'vehicle-model': {
// 				required: 'Please enter the model of your vehicle.'
// 			},
// 			'service-type': {
// 				required: 'Please choose a service type.'
// 			},
// 			'date-of-service': {
// 				required: 'Please choose a date for your service.'
// 			},
// 			'time-of-day': {
// 				required: 'Please choose the time of day for your service.'
// 			}
// 		},
// 		submitHandler: function(form) {
// 			$('.button-spinner', form).prop('disabled', true);
//
// 			var facility = $('#facility', form).val();
// 			var first_name = $('#first-name', form).val();
// 			var last_name = $('#last-name', form).val();
// 			var email_address = $('#email', form).val();
// 			var phone_number = $('#phone-number', form).val();
// 			var vehicle_year = $('#vehicle-year', form).val();
// 			var vehicle_make = $('#vehicle-make', form).val();
// 			var vehicle_model = $('#vehicle-model', form).val();
// 			var service_type = $('input[name="coupon-options"]:checked', form).val();
// 			var promo_code = $('#promo-code').val();
// 			var add_on_services = [];
// 			$('input[name="add-on-services"]:checked', form).each(function(index, service) {
// 				var add_on_service = {};
// 				add_on_service['title'] = $(service).attr('data-title');
// 				add_on_service['price'] = $(service).attr('data-price');
// 				add_on_service['price_in_pennies'] = $(service).attr('data-price-pennies');
// 				add_on_services.push(add_on_service);
// 			});
// 			if (add_on_services.length > 0) {
// 				add_on_services = JSON.stringify(add_on_services);
// 			}
// 			var date_of_service = $('#date-of-service', form).val();
// 			var time_of_day = $('#time-of-day', form).val();
// 			var additional_information = $('#additional-information', form).val();
// 			var price = $('#price', form).val();
// 			var nonce = $('#peak-car-wash-reservation-nonce', form).val();
//
// 			console.log(service_type);
//
// 			$.ajax({
// 				type: 'post',
// 				url: '/wp-admin/admin-ajax.php',
// 				data: {
// 					action: 'peak_car_wash_reservation_form',
// 					facility: facility,
// 					first_name: first_name,
// 					last_name: last_name,
// 					email_address: email_address,
// 					phone_number: phone_number,
// 					vehicle_year: vehicle_year,
// 					vehicle_make: vehicle_make,
// 					vehicle_model: vehicle_model,
// 					service_type: service_type,
// 					promo_code: promo_code,
// 					add_on_services: add_on_services,
// 					date_of_service: date_of_service,
// 					time_of_day: time_of_day,
// 					additional_information: additional_information,
// 					price: price,
// 					nonce: nonce
// 				},
// 				success: function(results) {
// 					var results = JSON.parse(results);
// 					console.log(results);
// 					if (results.status == 'success') {
// 						$('#payment-details .form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
// 					} else if (results.status == 'error') {
// 						$('#payment-details .form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
// 					}
// 					$('.button-spinner', form).prop('disabled', false);
// 				},
// 				error: function(results) {
// 					var results = JSON.parse(results);
// 					console.log(results);
// 					$('#payment-details .form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
// 					$('.button-spinner', form).prop('disabled', false);
// 				}
// 			});
// 		}
// 	});

});
